import { useRef, useState } from "react";
import { Box, IconButton, useTheme, Menu, MenuItem, Tooltip, Button } from "@mui/material";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { ColorModeContext, tokens } from "../../theme";
// import InputBase from "@mui/material/InputBase";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
// import SearchIcon from "@mui/icons-material/Search";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { setLogout } from "../../state";
// import AskMeDialogV2 from "../aiv2/AskMeDialogV2";
import AskMeDialogV3 from "../aiv2/AskMeDialogV3";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";
import { useSelector } from "react-redux";
import NotesDrawer from "../../components/NotesDrawer";

const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const dispatch = useDispatch();
  const triggerNotesRef = useRef(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const [openieQipCopilot, setOpenieQipCopilot] = useState(false);
  const [openNotes, setOpenNotes] = useState(false);

  const isOpen = Boolean(anchorEl);
  
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => {
    setAnchorEl(null);
    dispatch(setLogout());
  };

  const handleiEqipCopilotClick = (event) => {
    setOpenieQipCopilot(true);
  }

  const isAuthenticated = Boolean(useSelector((state) => {
    return state.isAuthenticated;
  }));

  const hasNotesPermission = isAuthenticated && Boolean(process.env.REACT_APP_NOTE_API_URL);

  const handleOpenNotes = () => {
    if (!hasNotesPermission) {
      return;
    }
    setOpenNotes(true);
  };

  const handleCloseNotes = () => {
    setOpenNotes(false);
  };

  return (
    <Box display="flex" justifyContent="space-between" p={2}>
      {/* SEARCH BAR */}
      <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      >
        {/* <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton> */}
      </Box>

      {/* ICONS */}
      <Box display="flex">
        <Tooltip title="Notes">
          <span>
            <Button
              aria-label="Open notes"
              variant="text"
              color="primary"
              startIcon={<StickyNote2OutlinedIcon />}
              onClick={handleOpenNotes}
              disabled={!hasNotesPermission}
              ref={triggerNotesRef}
            >
              Notes
            </Button>
          </span>
        </Tooltip>
        <Tooltip title={theme.palette.mode === "dark" ? "Light Mode" : "Dark Mode"}>
          <IconButton onClick={colorMode.toggleColorMode}>
            {theme.palette.mode === "dark" ? (
              <DarkModeOutlinedIcon />
            ) : (
              <LightModeOutlinedIcon />
            )}
          </IconButton>
        </Tooltip>
        {/* <IconButton>
          <NotificationsOutlinedIcon />
        </IconButton> */}
        <Tooltip title="ieQip Copilot">
          <IconButton color="primary">
            <AutoAwesomeIcon onClick={handleiEqipCopilotClick}/>
          </IconButton>
        </Tooltip>
        <IconButton>
          <PersonOutlinedIcon onClick={handleClick}/>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={isOpen}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <MenuItem onClick={handleClose}>Log Out</MenuItem>
        </Menu>
        <AskMeDialogV3 open={openieQipCopilot} setOpen={setOpenieQipCopilot}/>
        <NotesDrawer open={openNotes} onClose={handleCloseNotes} triggerRef={triggerNotesRef} />
      </Box>
    </Box>
  );
};

export default Topbar;
